import { ChatBubble } from '../../model/chat-bubble.model';

export function filterQuotesByDateTimeRange(
    dateRange: { from: Date; to: Date } | null,
    quotes: ChatBubble[],
): ChatBubble[] {
    if (dateRange == null || dateRange.from == null || dateRange.to == null) {
        return [...quotes];
    }

    return quotes.filter((q) => {
        const quoteTime = new Date(q.startTime).getTime() ?? 0;
        return (
            quoteTime >= new Date(dateRange.from).getTime() &&
            quoteTime <= new Date(dateRange.to).getTime()
        );
    });
}
